<template>
    <div class="status-bar">
        <p>{{ status }}</p>
    </div>
</template>

<script src="./status-bar.js"></script>
